module.exports = __webpack_public_path__ + "img/Pencil_Blue.ef8c6fed.svg";